<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <!-- <el-row style="padding-bottom: 15px;">
      <el-col :span="24">
        <h3 class="headtitle">科目类别信息</h3>
        <span>科目类别</span>
      </el-col>
    </el-row> -->
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <el-table
                        :data="tableData"
                        size="mini"
                        style="width: 100%; margin-top: 10px"
                        border
                    >
                        <el-table-column prop="name" label="科目类别名称" align="center">
                            <template slot-scope="scope">{{
                                scope.row.subjectType.subjectTypeName
                            }}</template>
                        </el-table-column>
                        <el-table-column prop="name" label="所属科目" align="center">
                            <template slot-scope="scope">{{
                                scope.row.subjectType.moduleMark
                            }}</template>
                        </el-table-column>
                        <el-table-column prop="name" label="科目属性" align="center">
                            <template slot-scope="scope">{{
                                scope.row.subjectType.typeProp
                            }}</template>
                        </el-table-column>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="subjectTypeUrl"
                        :GetData="initData"
                        :queryParam="queryParams"
                        :errorFunc="closeOpenloading"
                    ></pagerBar>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import pagerBar from "@/views/pager/pagerBar";
export default {
    data() {
        return {
            //TODO
            openloading: true,
            dialogVisible: false, // 弹窗显示
            tableData: [],
            moduleListUrl: config.BASE_Middle_API + "SubjectTypeUsers/GetModuleList",
            //科目类别列表数据获取
            subjectTypeUrl: config.BASE_Middle_API + "SubjectTypeUsers/GetAll",

            formLabel: {
                id: null,
                subjectTypeName: "",
                moduleMark: "",
            },
            queryParams: { Filter: "" },
            Modules: [],
        };
    },
    components: {
        pagerBar,
    },
    methods: {
        closeOpenloading() {
            this.openloading = false;
        },
        getModules() {
            const _this = this;
            AjaxHelper.get(_this.moduleListUrl)
                .then(function(response) {
                    if (response.success) {
                        _this.Modules = response.result;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },

        clearformLabel() {
            const _this = this;
            _this.formLabel.id = null;
            _this.formLabel.subjectTypeName = "";
            _this.formLabel.moduleMark = "";
        },
        initData(d) {
            const _this = this;
            _this.tableData = d;

            _this.openloading = false;
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh();
        },
        handleClose(done) {
            done();
        },
    },
};
</script>

<style scoped="scoped">
dt,
dd {
    margin: 0;
    padding: 0;
}
.el-card {
    height: calc(100vh - 154px) !important;
}
</style>
